import { render, staticRenderFns } from "./momentDetails.vue?vue&type=template&id=16e8f9e2"
import script from "./momentDetails.vue?vue&type=script&lang=js"
export * from "./momentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports